function atLocalNine(day: Date): Date {
  const next = new Date(day);
  next.setHours(9, 0, 0, 0);
  return next;
}

/** Tomorrow, three calendar days, or seven calendar days, at 9:00 local. */
export function snoozePresetUntil(
  preset: 'tomorrow' | 'three_days' | 'one_week',
  now: Date = new Date(),
): Date {
  const day = new Date(now);
  const offset = preset === 'tomorrow' ? 1 : preset === 'three_days' ? 3 : 7;
  day.setDate(day.getDate() + offset);
  return atLocalNine(day);
}

export function toDateTimeLocalValue(date: Date): string {
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function fromDateTimeLocalValue(value: string): Date | null {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** True when a chosen instant is already behind `now`. An empty choice is not past. */
export function isSnoozeInstantInPast(until: Date | null, now: Date): boolean {
  return until != null && until.getTime() <= now.getTime();
}
